<app-dialog class="note"
    [showHeader]="true"
    [header]="'Add new note'"
    [minWidth]="640"
    [show]="true"
    [hideHeaderUnderline]="true">
  <app-selected-ndc-input
      [drug]="noteDetails"
      label="Drug you’re recording an audit note on"
      customClasses="text-[15px]"
    ></app-selected-ndc-input>
    <div class="adjustment-data">
      <span class="font-medium">Adjustment Quantity</span>
      <app-input
        class="!w-[80px] pl-4"
        [type]="'number'"
        textAlign="right"
        [showErrors]="true"
        [invalid]="adjustmentQtyInvalid"
        [autofocus]="true"
        (valueChanged)="noteAdjustmentQtyChanged($event)"
        #adjustmentInput
      > </app-input>
      <span class="pl-8">Current discrepancy: {{leftDiscrepancyToAdjust}}</span>
    </div>
    <app-error-message *ngIf="adjustmentQtyInvalid && !adjustmentQtyEmpty">
      Quantity cannot be greater than discrepancy
    </app-error-message>
    <app-error-message *ngIf="adjustmentQtyInvalid && adjustmentQtyEmpty">
      Quantity cannot be empty or 0
    </app-error-message>
    <div class="divider"></div>
    <app-textarea label="Explain the discrepancy" [optional]="false"
    (valueChanged)="noteDescriptionChanged($event)"
    (keydownTab)="discrepancyExplainationTextAreaTabKeyPressed()">
    </app-textarea>
    
    <div class="dialog-controls-default !border-0">
      <app-button [minWidth]="0"
                  customClasses="px-4"
                  subStyle="transparent"
                  class="cancel-btn"
                  text="Cancel"
                  (clicked)="cancel.emit()"
                  [tabIndex]="2"
                  (keydownTab)="focusAdjustmentInput()"
                  #closeButton
      ></app-button>
      <app-button customClasses="px-4"
                  [minWidth]="0"
                  class="invite-btn"
                  text="Add"
                  (clicked)="submitAdjustment()"
                  [disabled]="adjustmentQtyInvalid || !noteDescription"
                  (keydownTab)="focusAdjustmentInput()"
                  #submitButton
      ></app-button>
    </div>
</app-dialog>